import {
  PERFORMANCE_TARGET_COMPARISONS,
  PERFORMANCE_TARGET_METRICS,
  type PerformanceTargetComparison,
} from '@nightshift/ui-types';

import { canWriteSettings } from './privilege.ts';

export const TARGET_METRIC_OPTIONS = PERFORMANCE_TARGET_METRICS.filter((metric) => metric !== 'fps');

const TARGET_COMPARISON_LABELS: Record<PerformanceTargetComparison, string> = {
  lt: 'less than',
  lte: 'at most',
  gt: 'greater than',
  gte: 'at least',
};

export function canWritePerformanceTargets(user: { role: string } | null): boolean {
  return canWriteSettings(user);
}

export function comparisonOptions(): Array<{ id: PerformanceTargetComparison; label: string }> {
  return PERFORMANCE_TARGET_COMPARISONS.map((id) => ({ id, label: TARGET_COMPARISON_LABELS[id] }));
}
